import React from 'react';
import PropTypes from 'prop-types';
import scrollIntoView from 'scroll-into-view';
import cn from 'classnames';

import styles from './styles.m.scss';

import Collapse from './Collapse';

const propTypes = {
  as: PropTypes.any.isRequired,
  currentStep: PropTypes.number,
  name: PropTypes.string.isRequired,
  setStep: PropTypes.func,
  step: PropTypes.number,
  totalSteps: PropTypes.number,
};

function scrollToExpandingElement(elem) {
  scrollIntoView(elem.parentElement, { behavior: 'smooth', block: 'start' });
  return elem;
}

const Step = ({ as: Component, currentStep, highestStep, setStep, step, title, totalSteps, ...props }) => {
  const stepProps = {
    ...props,
    setStep,
    step,
  };
  const clickable = highestStep >= step;

  return (
    <div>
      <p
        className={cn('bold-blue-heading', { clickable: clickable }, styles.step)}
        onClick={() => clickable && setStep(step)}
      >
        Step {step + 1}: {title}
      </p>
      <Collapse in={currentStep == step} onEntered={scrollToExpandingElement}>
        <div>
          <Component {...stepProps} />
        </div>
      </Collapse>
    </div>
  );
};

Step.propTypes = propTypes;

export default Step;
